var _style, _circle, _path, _g, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _polygon, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 120.2",
    style: {
      enableBackground: "new 0 0 120.2 120.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCFF00;}\n\t.st1{fill:#1CD8D2;}\n\t.st2{fill:#A4EFED;}\n\t.st3{fill:none;stroke:#EBFF99;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1,
    cy: 60.1,
    r: 60.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.7,51.2c-5.8,0-11.3,1.8-15.8,4.7l1.2,7.3c3.9-3.4,9-5.5,14.6-5.5c12.2,0,22.2,10,22.2,22.2 s-10,22.3-22.2,22.3c-12.2,0-22.2-10-22.2-22.3c0-1.7,0.2-3.3,0.5-4.8l-2-11.6C35.9,68.3,34,73.9,34,80c0,15.9,12.9,28.8,28.7,28.8 s28.7-13,28.7-28.8S78.6,51.2,62.7,51.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.8,96.4c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9s-3.9,1.8-3.9,3.9C56.9,94.7,58.6,96.4,60.8,96.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.6,92.5c2.2,0,3.9-1.8,3.9-3.9s-1.8-3.9-3.9-3.9s-3.9,1.8-3.9,3.9C67.7,90.7,69.4,92.5,71.6,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,84.6c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9 C58.4,82.9,60.1,84.6,62.3,84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.9,88.6c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9 C45.9,86.8,47.7,88.6,49.9,88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.5,79.4c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9 C71.6,77.7,73.3,79.4,75.5,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.7,71.1c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9 C63.7,69.3,65.5,71.1,67.7,71.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8,75c2.2,0,3.9-1.8,3.9-3.9c0-2.2-1.8-3.9-3.9-3.9c-2.2,0-3.9,1.8-3.9,3.9C49.9,73.3,51.6,75,53.8,75z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 67.7,
    cy: 67.2,
    r: 1.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 71.6,
    cy: 88.6,
    r: 1.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 75.5,
    cy: 75.5,
    r: 1.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 53.8,
    cy: 71.1,
    r: 1.9
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 49.9,
    cy: 84.6,
    r: 1.9
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 62.3,
    cy: 80.7,
    r: 1.9
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 60.8,
    cy: 92.5,
    r: 1.9
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 62.6,
    cy: 80,
    r: 25.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "48.2,63.2 41.3,77.4 38.5,60.1 46.9,55.9 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,78.8c-1.8,0-3.3-1.3-3.6-3.1L31.8,15.6c-0.2-1,0.1-1.9,0.6-2.7c0.6-0.8,1.4-1.3,2.4-1.5 c2-0.3,3.9,1,4.2,3l10.2,60.1c0.2,1-0.1,1.9-0.6,2.7c-0.6,0.8-1.4,1.3-2.4,1.5C46.1,78.8,45.8,78.8,45.7,78.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 35.4,
    y1: 15.1,
    x2: 45.7,
    y2: 75
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaToken);
export default __webpack_public_path__ + "static/media/boba-token.cf96f17d5263309878f12e10f8ea1205.svg";
export { ForwardRef as ReactComponent };